import React from "react";
import { ChevronDown } from "lucide-react";
type FormFieldProps = {
  label: string;
  value?: string;
  placeholder?: string;
  select?: boolean;
  required?: boolean;
};
export function FormField({
  label,
  value,
  placeholder = "নির্বাচন করুন",
  select = true,
  required = true
}: FormFieldProps) {
  return <label className="block" data-id="element-93" data-mp="25d6pso11c4j8"><span className="mb-1.5 flex text-xs font-bold text-[#38473d]" data-id="element-94" data-mp="25cn5j0nwx421">{label}{required && <span className="ml-0.5 text-[#D62828]" data-id="element-95" data-mp="2kafns0kug6jx">*</span>}</span><div className="flex h-12 items-center justify-between rounded-xl border border-[#cfdfd3] bg-white px-3.5 text-sm text-[#1D2A22] shadow-sm" data-id="element-96" data-mp="2k8uo5wjo9xf7"><span className={value ? "" : "text-[#8a998f]"} data-id="element-97" data-mp="2t3sk7ci49qar">{value || placeholder}</span>{select && <ChevronDown size={18} className="text-[#66756B]" data-id="element-98" data-mp="2p1xmsj3b3x29" />}</div></label>;
}